import React from "react"

// Components
import IconButton from "src/components/common/icon-button/index.jsx"

// Icons
import { Sun1, Moon } from "iconsax-react"

// Hooks
import useConfigStore from "src/store/config/index.js"
import { useIsMobile } from "../../../../../hooks/useIsMobile"

// --------------------------------------------------|| DARK MODE - COMPONENTS || -----------------------------------------

const DarkMode = () => {
  const { themeMode, onChangeMode } = useConfigStore()
  const isMobile = useIsMobile()

  const changeTheme = () => {
    if (themeMode === "light") {
      onChangeMode("dark")
    } else {
      onChangeMode("light")
    }
  }

  return (
    <IconButton sx={{ ml: isMobile ? 0 : 1, boxShadow: 3 }} onClick={changeTheme}>
      {themeMode === "dark" ? <Moon size={18} /> : <Sun1 size={18} />}
    </IconButton>
  )
}

export default DarkMode
